import React from 'react';
import { Box, TextField, IconButton } from '@mui/material';
import { Send } from 'lucide-react';

interface ChatInputProps {
  query: string;
  loading: boolean;
  isAnimating: boolean;
  onQueryChange: (value: string) => void;
  onSend: () => void;
}

const ChatInput: React.FC<ChatInputProps> = ({
  query,
  loading,
  isAnimating,
  onQueryChange,
  onSend,
}) => {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <Box sx={{ p: 2, bgcolor: 'white', borderTop: 1, borderColor: 'divider', flexShrink: 0 }}>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <TextField
          fullWidth
          size="small"
          multiline
          maxRows={2}
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Ask about your fleet..."
          disabled={loading}
          variant="outlined"
        />
        <IconButton
          color="primary"
          onClick={onSend}
          disabled={loading || isAnimating || !query.trim()}
          sx={{ alignSelf: 'flex-end' }}
        >
          <Send size={20} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ChatInput;
